(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["xun-zal-header"] && !Shopify.designMode) return;
  try {
    
function initXzHeader(root){root.querySelectorAll('.xz-offer[data-xz-deadline]').forEach(bar=>{if(bar.dataset.xzBound)return;bar.dataset.xzBound='true';const end=Date.parse(bar.dataset.xzDeadline);if(!Number.isFinite(end))return;const clock=bar.querySelector('[data-xz-clock]');const link=bar.querySelector('[data-xz-offer-link]');let interval;const tick=()=>{if(!bar.isConnected){clearInterval(interval);return;}const remaining=Math.floor((end-Date.now())/1000);if(remaining<=0){bar.hidden=true;clearInterval(interval);return;}clock.hidden=false;link.hidden=true;clock.textContent=[Math.floor(remaining/3600),Math.floor(remaining/60)%60,remaining%60].map(n=>String(n).padStart(2,'0')).join(':');};tick();interval=setInterval(tick,1000);});}
initXzHeader(document);document.addEventListener('shopify:section:load',e=>initXzHeader(e.target));document.addEventListener('click',e=>{document.querySelectorAll('.xz-header details[open]').forEach(d=>{if(!d.contains(e.target))d.open=false;});});document.addEventListener('keydown',e=>{if(e.key==='Escape')document.querySelectorAll('.xz-header details[open]').forEach(d=>d.open=false);});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["xun-zal-product"] && !Shopify.designMode) return;
  try {
    
function initXzProduct(root){root.querySelectorAll('.xz-product').forEach(page=>{if(page.dataset.xzBound)return;page.dataset.xzBound='true';const image=page.querySelector('.xz-main-image');const thumbs=[...page.querySelectorAll('button[data-xz-image]')];const radios=[...page.querySelectorAll('input[name="id"]')];const buy=page.querySelector('.xz-buy');let current=Math.max(0,thumbs.findIndex(t=>t.getAttribute('aria-pressed')==='true'));
const changeImage=src=>{if(!src)return;image.removeAttribute('srcset');image.src=src;thumbs.forEach((t,i)=>{const active=t.dataset.xzImage===src;t.setAttribute('aria-pressed',String(active));if(active)current=i;});};
const update=()=>{const selected=radios.find(r=>r.checked);if(!selected)return;page.querySelectorAll('[data-xz-price]:not(input)').forEach(el=>el.textContent=selected.dataset.xzPrice);const compare=page.querySelector('[data-xz-compare]:not(input)');compare.textContent=selected.dataset.xzCompare;compare.hidden=!selected.dataset.xzCompare;const saving=page.querySelector('[data-xz-saving]:not(input)');saving.textContent=selected.dataset.xzSaving;saving.hidden=!selected.dataset.xzSaving;buy.disabled=selected.dataset.xzAvailable!=='true';buy.textContent=buy.disabled?buy.dataset.xzUnavailable:buy.dataset.xzLabel;changeImage(selected.dataset.xzImage);const url=new URL(location.href);url.searchParams.set('variant',selected.value);history.replaceState(null,'',url.toString());};
radios.forEach(r=>r.addEventListener('change',update));thumbs.forEach(t=>t.addEventListener('click',()=>changeImage(t.dataset.xzImage)));page.querySelector('.xz-gallery-prev').addEventListener('click',()=>{if(thumbs.length)thumbs[(current-1+thumbs.length)%thumbs.length].click();});page.querySelector('.xz-gallery-next').addEventListener('click',()=>{if(thumbs.length)thumbs[(current+1)%thumbs.length].click();});
page.querySelectorAll('.xz-market-form').forEach(form=>form.addEventListener('submit',()=>{form.querySelectorAll('[name="return_to"]').forEach(input=>input.value=location.pathname+location.search);}));
const sticky=page.querySelector('.xz-sticky');if(sticky){const observer=new IntersectionObserver(entries=>{if(!page.isConnected){observer.disconnect();return;}entries.forEach(entry=>sticky.classList.toggle('is-visible',!entry.isIntersecting&&entry.boundingClientRect.top<0));});observer.observe(buy);}
update();});}
initXzProduct(document);document.addEventListener('shopify:section:load',e=>initXzProduct(e.target));

  } catch(e) { console.error(e); }
})();
})();
